enum CameraScheduleEnum {
  DETECT = 1,
  DISABLED = 2,
}

export default CameraScheduleEnum;
